/**
 * Dimension and weight parsing / formatting.
 * Dimensions stored as integer inches; weight as integer pounds.
 */
/** Parse a free-text dimension into integer inches, or null if unparseable. */
export function parseDim(raw) {
    const s = raw.trim().toLowerCase().replace(/,/g, "");
    if (!s)
        return null;
    // 8 ft 6 in / 8ft 6in / 8 feet 6 inches
    let m = s.match(/^(\d+(?:\.\d+)?)\s*(?:ft|feet|')\s*(\d+(?:\.\d+)?)\s*(?:in|inches|")?$/);
    if (m) {
        const ft = Number(m[1]);
        const inches = Number(m[2]);
        return Math.round(ft * 12 + inches);
    }
    // 8'6" or 8'6
    m = s.match(/^(\d+)\s*'\s*(\d+)\s*"?$/);
    if (m) {
        return Math.round(Number(m[1]) * 12 + Number(m[2]));
    }
    // 102 in / 102 inches / 102"
    m = s.match(/^(\d+(?:\.\d+)?)\s*(?:in|inches|")$/);
    if (m) {
        return Math.round(Number(m[1]));
    }
    // 8.5 ft / 8.5 feet / 8 ft
    m = s.match(/^(\d+(?:\.\d+)?)\s*(?:ft|feet|')$/);
    if (m) {
        return Math.round(Number(m[1]) * 12);
    }
    // Bare number: <20 treated as feet, else inches
    m = s.match(/^(\d+(?:\.\d+)?)$/);
    if (m) {
        const n = Number(m[1]);
        if (n < 20) {
            return Math.round(n * 12);
        }
        return Math.round(n);
    }
    return null;
}
/** Format integer inches as "X ft Y in". */
export function formatDim(inches) {
    const whole = Math.round(inches);
    const ft = Math.floor(whole / 12);
    const inn = whole % 12;
    return `${ft} ft ${inn} in`;
}
/** Parse weight text into integer pounds. */
export function parseWeight(raw) {
    const s = raw.trim().toLowerCase().replace(/,/g, "");
    if (!s)
        return null;
    // 24 t / 24 ton / 24 tons (short tons × 2000)
    let m = s.match(/^(\d+(?:\.\d+)?)\s*(?:t|ton|tons)$/);
    if (m) {
        return Math.round(Number(m[1]) * 2000);
    }
    // 48k / 48 k
    m = s.match(/^(\d+(?:\.\d+)?)\s*k$/);
    if (m) {
        return Math.round(Number(m[1]) * 1000);
    }
    // 48000 / 48000 lb / 48000 lbs / 48000#
    m = s.match(/^(\d+(?:\.\d+)?)\s*(?:lb|lbs|#)?$/);
    if (m) {
        return Math.round(Number(m[1]));
    }
    return null;
}
/**
 * Default deck height (inches) for trailer type keywords.
 * step/drop deck 42, rgn/lowboy/double drop 24,
 * van/reefer enclosed 110, flat/conestoga/stretch 60.
 */
export function deckFor(trailerHint) {
    const s = trailerHint.trim().toLowerCase();
    if (/\b(rgn|lowboy|low boy|double\s*drop|dbl\s*drop)\b/.test(s) ||
        s.includes("lowboy")) {
        return 24;
    }
    if (/\b(step|drop\s*deck|stepdeck)\b/.test(s)) {
        return 42;
    }
    if (/\b(van|reefer|refrigerat|enclosed|dry\s*van)\b/.test(s)) {
        return 110;
    }
    if (/\b(flat|conestoga|stretch|flatbed)\b/.test(s)) {
        return 60;
    }
    return 60;
}
//# sourceMappingURL=dims.js.map